export default {"src":"/_next/static/media/icSpace.03ad4245.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};